import { createSlice, createSelector } from "@reduxjs/toolkit";

const rolesSliceSelector = createSlice({
  name: "rolesSlice",
  initialState: {
    isLoading: false,
    loaderMessage : "",
    isLoadingNewAdd : false,
    rolesList: [],
    usersRoleList :[]
  },
  reducers: {
    startGettingRolesList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    startDeleteRolesList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    setRolesList(state, action) {
      state.rolesList = action.payload;
    },
    startGettingFilterRolesList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    setRolesFilterList(state, action) {
      state.rolesList = action.payload;
    },
    startRolesListByUserId(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    setUserRolesList(state, action) {
      state.usersRoleList = action.payload;
    },
    startAddUserRolesList(state, action) {
      state.isLoading = true;
      state.loaderMessage = "Loading please wait..."
    },
    startAddNewRole(state , action){
      state.isLoadingNewAdd = true;
      state.loaderMessage = "Adding role please wait..."
    },
    completedFetch(state, action) {
      state.isLoading = false;
      state.loaderMessage = ""
    },
    completedNewAdd(state, action) {
      state.isLoadingNewAdd = false;
      state.loaderMessage = ""
    },
  },
});

export const { startGettingRolesList, startDeleteRolesList, setRolesList, startGettingFilterRolesList, setRolesFilterList ,startAddNewRole,completedFetch ,completedNewAdd , startRolesListByUserId , setUserRolesList, startAddUserRolesList } = rolesSliceSelector.actions;
export default rolesSliceSelector.reducer;

//Selector
const mainReducer = (state) => state.RolesStore;

export const rolesListSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.rolesList
);

export const userRolesListSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.usersRoleList
);

export const isLoadingRolesSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.isLoading
);
export const isLoadingForNewAddSelector = createSelector(
  [mainReducer],
  (stateReducer) => stateReducer.isLoadingNewAdd
);
export const loaderMessageSelector = createSelector(
  [mainReducer],
  (myReducerStore)=> myReducerStore.loaderMessage
);